import React from 'react';
import Icon from '../../../components/AppIcon';

const CategoryFilter = ({ categories, activeCategory, onCategoryChange }) => {
  return (
    <div className="flex flex-wrap gap-3 justify-center mb-12">
      {categories?.map((category) => {
        const isActive = activeCategory === category?.id;
        
        return (
          <button
            key={category?.id}
            onClick={() => onCategoryChange(category?.id)}
            className={`group relative px-6 py-3 rounded-full font-medium transition-all duration-300 ${
              isActive
                ? `${category?.activeClass} text-white shadow-lg scale-105`
                : 'bg-white text-gray-600 hover:bg-gray-50 border border-gray-200 hover:border-gray-300'
            }`}
          >
            <div className="flex items-center gap-2">
              <Icon 
                name={category?.icon} 
                size={18} 
                className={isActive ? 'text-white' : 'text-gray-500 group-hover:text-gray-700'} 
              />
              <span>{category?.name}</span>
              <span className={`text-xs px-2 py-1 rounded-full ${
                isActive 
                  ? 'bg-white/20 text-white' :'bg-gray-100 text-gray-500 group-hover:bg-gray-200'
              }`}>
                {category?.count}
              </span>
            </div>
            {/* Active indicator */}
            {isActive && (
              <div className="absolute -bottom-1 left-1/2 transform -translate-x-1/2 w-2 h-2 bg-white rounded-full" />
            )}
          </button>
        );
      })}
    </div>
  );
};

export default CategoryFilter;